import React from 'react';

interface Props {
  message: string;
  colSpan: number;
}

const styles = {
  tableEmpty: {
    textAlign: 'center' as const,
    padding: '30px 20px',
    color: 'var(--text3)',
    fontSize: 13,
  },
};

export default function TableEmpty({ message, colSpan }: Props): JSX.Element {
  return (
    <tr>
      <td colSpan={colSpan} className="no-bg-hover">
        <div style={styles.tableEmpty}>
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2">
            <circle cx="11" cy="11" r="8" />
            <path d="M21 21l-4.35-4.35" />
          </svg>

          <p>{message}</p>
        </div>
      </td>
    </tr>
  );
}
